import React from 'react';

import { useEventTracker } from '../hooks/useEventTracker';

/**
 * Activates event tracking for authenticated users outside impersonation sessions.
 * Must be rendered inside AuthProvider.
 */
export const EventTrackerProvider: React.FC = () => {
  useEventTracker();

  return null;
};

export default EventTrackerProvider;
